import { ActivityEditPage, EditPageProps } from "../ActivityEditPage"

export const ActivityDuplicatePage = (props: EditPageProps) => {
  return <ActivityEditPage isDuplicating {...props} />
}
